(function () {

	$('.indextab .tabs').each(function () {

		var $tabs = $(this);
		var tabs = this;

		var isDown = false;
		var isDragging = false;
		var startX = 0;
		var startScrollLeft = 0;
		var dragThreshold = 5;

		$tabs.on('mousedown', function (e) {

			if (e.which !== 1) return;

			isDown = true;
			isDragging = false;

			startX = e.pageX;
			startScrollLeft = tabs.scrollLeft;

			$tabs.addClass('is-dragging');

		});

		$(document).on('mousemove', function (e) {

			if (!isDown) return;

			var moveX = e.pageX - startX;

			if (Math.abs(moveX) > dragThreshold) {
				isDragging = true;
			}

			if (!isDragging) return;

			e.preventDefault();

			tabs.scrollLeft = startScrollLeft - moveX;

		});

		$(document).on('mouseup', function () {

			if (!isDown) return;

			isDown = false;

			$tabs.removeClass('is-dragging');

			setTimeout(function () {
				isDragging = false;
			}, 0);

		});

		$tabs.on('click', '.link', function (e) {

			if (!isDragging) return;

			e.preventDefault();
			e.stopImmediatePropagation();

		});

	});
})();
